import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import "./firebase/firebaseConfig";

// Rutas secundarias cargadas bajo demanda (Code Splitting)
const AboutUsPage = lazy(() => import("./pages/AboutUsPage"));
const CoursesPage = lazy(() => import("./pages/CoursesPage"));
const PricingPlansPage = lazy(() => import("./pages/PricingPlansPage"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const LegalPrivacyPage = lazy(() => import("./pages/LegalPrivacyPage"));
const TimeEstimatorCalculator = lazy(() => import("./pages/TimeEstimatorCalculator"));
const ChecklistPortal = lazy(() => import("./pages/ChecklistPortal"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

const RouteLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0d1b22]">
    <div className="w-8 h-8 rounded-full border-2 border-cyan-500 border-t-transparent animate-spin" />
  </div>
);

const App = () => {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Suspense fallback={<RouteLoader />}>
          <Routes>
            <Route path="/" element={<MainLayout />} />
            <Route path="/nosotros" element={<AboutUsPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/planes" element={<PricingPlansPage />} />
            <Route path="/pricing" element={<PricingPlansPage />} />
            <Route path="/cursos" element={<CoursesPage />} />
            <Route path="/academy" element={<CoursesPage />} />
            <Route path="/terminos" element={<TermsAndConditions />} />
            <Route path="/privacidad" element={<LegalPrivacyPage />} />
            <Route path="/calculadora-tiempos" element={<TimeEstimatorCalculator />} />
            <Route path="/checklist" element={<ChecklistPortal />} />
            {/* Esta ruta captura todo lo no definido */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
